// Initials for an organization avatar tile (account menu row, org switcher): the first letter of
// the first two words, skipping joining words — "Reliant Ribbon Corp" → "RR", "Alder and Finch" →
// "AF". A one-word name takes its first two letters ("Canrad" → "CA") so the tile never reads as a
// single stray letter. Blank names give an empty string, which the tile renders as nothing.

const JOINERS = new Set(['and', '&', 'of', 'the', 'for', 'de', 'du', 'la', 'le', 'y']);

export function orgInitials(name: string | null | undefined): string {
    const words = (name ?? '')
        .split(/\s+/)
        .filter((word) => word.length > 0 && !JOINERS.has(word.toLowerCase()));

    if (words.length === 1) {
        const letters = words[0].match(/[\p{L}\p{N}]/gu) ?? [];
        return letters.slice(0, 2).join('').toUpperCase();
    }

    return words
        .map((word) => word.match(/[\p{L}\p{N}]/u)?.[0] ?? '')
        .filter((letter) => letter.length > 0)
        .slice(0, 2)
        .join('')
        .toUpperCase();
}
